import axios from "axios";

export const API_URL = process.env.REACT_APP_SAHIKHOJ_API_URL;

const TOKEN_KEY = "sahikhoj_session_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API_URL, timeout: 45000 });

api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (error) => {
        if (error?.response?.status === 401 && getToken()) {
            clearToken();
            window.dispatchEvent(new Event("auth:expired"));
        }
        return Promise.reject(error);
    }
);

export const apiError = (e) => {
    const detail = e?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((x) => (typeof x?.msg === "string" ? x.msg : "")).filter(Boolean).join(" ") || "Request failed.";
    if (e?.response?.status === 429) return "Too many requests. Please wait a moment and try again.";
    return e?.message || "Something went wrong. Please try again.";
};

export const goUrl = (offerId) => `${API_URL}/go/${offerId}`;

export const trackClick = (offerId, sourcePage = "web") =>
    api.post("/clicks", { offerId, sourcePage }).catch(() => {});

export const trackView = (offerId) =>
    api.post(`/offers/${offerId}/view`).catch(() => {});
